<template>
  <!-- 藏品列表 -->
  <div class="page-collect">
    <div class="g-banner white">
      <cmpBanner bannerType="3"></cmpBanner>

      <div class="g-tab-box">
        <cmpTab ref="cmpTab" :tabs="tabList" :activeVal="activeVal" @eventTabClick="eventTabClick"></cmpTab>
      </div>
    </div>

    <div class="g-content-wrap g-pad-top">
      <!-- 搜索条件 -->
      <div class="com-list-header">
        <el-form class="com-search-box" ref="form" :model="form" label-width="0">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="" prop="name">
                <el-input v-model="form.name" clearable placeholder="文物名称："></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="" prop="year">
                <el-select v-model="form.year" clearable placeholder="文物年代" style="width:100%;">
                  <el-option
                    v-for="item in yearList"
                    :key="item.dictCode"
                    :label="item.dictName"
                    :value="item.dictCode"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="" prop="category">
                <el-select v-model="form.category" clearable placeholder="文物类别" style="width:100%;">
                  <el-option
                    v-for="item in typeList"
                    :key="item.dictCode"
                    :label="item.dictName"
                    :value="item.dictCode"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="6">
              <el-form-item label="" prop="orgId">
                <el-select v-model="form.orgId" clearable placeholder="收藏单位" style="width:100%;">
                  <el-option
                    v-for="item in orgList"
                    :key="item.orgId"
                    :label="item.orgName"
                    :value="item.orgId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-form>

        <div class="com-head-search-btns">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <!-- <el-button @click="restList">重置</el-button> -->
        </div>
      </div>

      <!-- <div class="title-box">
        <img class="title-pic" src="@images/collect-list.jpg" alt="">
        <div class="title-desc">
          <div>
            <p class="mb-10">共公开</p>
            <p><span class="count">{{total | thousandsFormat}}</span> 件藏品</p>
          </div>
        </div>
      </div> -->

      <div class="list-box mt-40">
        <div class="list masonry-container g-pad-bottom-2" v-masonry transition-duration="0" item-selector=".item" :gutter="gutter">
          <div v-masonry-tile class="item" :class="{'min': gutter<25}" v-for="(item, index) in dataList" :key="index" @click="goDetailCollect(item)">
            <div class="pic-box" v-if="item.mainCollectImages">
              <img :src="item.mainCollectImages||''" :onerror="$store.state.app.defaultImg">
              <!-- <div class="tag-box">
                <span class="tag">{{item.categoryName}}</span>
                <span class="tag">{{item.yearName}}</span>
              </div> -->
              <div class="icon-3d-box g-pointer" v-show="!isDeday">
                <i class="icon-3d"></i>
              </div>
            </div>
            <div class="info">
              <h2 class="ell">{{item.collectName}}</h2>
              <p>{{item.collectYear}}</p>

              <!-- <myCmpLike class="like-box" :isLike="item.iscollection?true:false" :likeId="item.id" :type="`1`" style="top:20px;"></myCmpLike> -->
            </div>
          </div>

          <!-- 无数据 -->
          <div class="g-no-data" v-if="dataList.length === 0 && !listLoading">
            <div class="no-data-bg"></div>
            <p class="txt text-center">暂无数据</p>
          </div>
        </div>

        <cmpMyPagination :currentPage="listQuery.currentPage" :pageSize="listQuery.size" :total="total" @eventPage="eventPage"></cmpMyPagination>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {VueMasonryPlugin} from 'vue-masonry'
Vue.use(VueMasonryPlugin)

import cmpTab from '@cmp/tab'
import myCmpLike from '@cmp/my-like'
export default {
  components: { cmpTab, myCmpLike },
  data() {
    return {
      activeVal: '2',
      tabList: [
        {
          name: '馆藏精品',
          val: '1'
        },
        {
          name: '3D 藏品',
          val: '2'
        },
        {
          name: '数字文物库',
          val: '3'
        },
        // {
        //   name: '文物素材库',
        //   val: '4'
        // }
      ],
      dataList: [],
      listQuery: {
        currentPage: 1,
        size: 20,
      },
      total: 0,
      listLoading: true,
      form: {
        year: '',
        category: '',
        name: '',
      },
      totalCol: 0,
      yearList: [],
      typeList: [],
      orgList: [],
      gutter: 25,
      isDeday: true
    }
  },
  methods: {
    getDataList() {
      this.isDeday = true
      this.listLoading = true
      this.$http
        // .get('/collection/getCollectionList.do', {
        .get('../singleMuseum/bs/bsDigitalRelics/list', {
          ...this.form,
          ...this.listQuery,
          three: '1'  // 1 3d藏品
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            let data = res.result || {}
            data.records.map(item => {
							if (item.collectImages) {
								item.mainCollectImages = item.collectImages[0] && item.collectImages[0].attPath
							} else {
								item.mainCollectImages = ''
							}
              console.log(item)
						})

            this.dataList = data.records
            this.total = data.total

            this.reDraw()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    reDraw() {
      this.$nextTick(() => {
        if(document.body.clientWidth < 1440) {
          this.gutter = 20
        } else {
          this.gutter = 25
        }
        setTimeout(() => {
          this.$redrawVueMasonry()
        }, 500)

        setTimeout(() => {
          this.isDeday = false
        }, 2000)
      })
    },
    getDictData() {
      this.$http
        .get('../singleMuseum/bs/bsDigitalRelics/dict', {
        }).then(res => {
          if (res.success) {
            let data = res.result
            this.yearList = data.collection_year
            this.typeList = data.collection_type
          } else {
            this.$message.error(res.message)
          }
        })
      // this.$http
      //   .get('/collection/getCollectionSearch.do', {
      //   }).then(res => {
      //     if (res.success) {
      //       let data = res.data
      //       this.totalCol = data.allCol
      //       this.yearList = data.yearTypeList
      //       this.typeList = data.typeList
      //       this.orgList = data.orgList

      //       if(this.$route.query.type) {
      //         this.form.type = this.$route.query.type
      //       }
      //       this.getDataList()
      //     } else {
      //       this.$message.error(res.message)
      //     }
      //   })
    },
    handleSearch() {
      this.listQuery.currentPage = 1
      this.getDataList()
    },
    goDetailCollect(item) {
      this.$router.push({
        path: '/collect/detail',
        query: {id: item.collectId, pageType: '2'}
      })
    },
    goDetailTopic(item) {
      this.$router.push({
        path: '/collect/topic/detail',
        query: {id: '1'}
      })
    },
    eventTabClick(val) {
      if(val === this.activeVal) return
      this.activeVal = val
      if(val === '1') {
        this.$router.push('/collect')
      } else if(val === '2') {
        this.$router.push('/collect/list')
      } else if(val === '3') {
        this.$router.push('/collect/digital-culture')
      } else if(val === '4') {
        this.$router.push('/collect/material')
      }
      // console.log(val)
      // this.activeVal = val
      // this.listQuery.currentPage = 1
      // this.getDataList()
    },
    eventPage(obj) {
      this.listQuery.currentPage = obj.currentPage
      this.listQuery.size = obj.size
      this.getDataList()

      window.scrollTo({
        top: 0
      })
    },
  },
  created() {
    this.getDictData()
    this.getDataList()
  },
  mounted() {
    window.addEventListener('resize', this.reDraw)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.reDraw)
  }
}
</script>

<style lang="scss" scoped>
.page-collect {
  // background: #D4BE95;
  // color: #fff;
  .title-box {
    margin-top: 40px;
    position: relative;
    .title-pic {
      width: 100%;
      height: 136px;
    }
    .title-desc {
      position: absolute;
      left: 50px;
      top: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 136px;
      font-size: 18px;
      color: #fff;
      h1 {
        font-size: 36px;
      }
      .count {
        font-size: 38px;
        font-weight: bold;
      }
    }
  }

  .list-box {
    
  }

  .masonry-container {
    .g-card-list {
      display: initial;
    }
    .item {
      position: relative;
      margin-bottom: 35px;
      width: 375px;
      cursor: pointer;
      &.min {
        width: 360px;
      }
      .pic-box {
        position: relative;
        img {
          width: 100%;
          min-height: 200px;
        }
      }
      .info {
        padding: 28px 40px;
        background: rgba($color: #E1D9C8, $alpha: 0.4);
        font-size: 18px;
        // color: #fff;
        h2 {
          font-size: 24px;
          margin-bottom: 15px;
        }
      }
    }
  }

  .icon-3d-box {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 3;
    width: 80px;
    height: 80px;
    border-radius: 100%;
    background: rgba($color: #000000, $alpha: 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    transform: scale(0.6);
    .icon-3d {
      display: inline-block;
      width: 49px;
      height: 56px;
      background: url(~@images/icon-3d.png) no-repeat center center;
      background-size: 100% 100%;
    }
  }

  // /deep/ .el-input {
  //   .el-input__inner {
  //     // color: rgba($color: #000000, $alpha: 0.7);
  //     &::placeholder { 
  //       color: rgba($color: #000000, $alpha: 0.5);
  //     }
  //   }
  // }
  // /deep/ .el-select:hover .el-input__inner {
  //   border-color: #fff;
  // }
  // /deep/ .el-select .el-input .el-select__caret {
  //   color: $primary;
  // }
}
</style>